$(document).ready(function () {
  $(".nav-item-search").click(function () {
    var search = $("#Search").hasClass("show");
    if (search == true) {
      $("#Search").removeClass("show");
    }
    else {
      $("#Search").addClass("show");
    }
  });
  
  if ($(window).width() < 992) {
    $('.nav-item.dropdown').on('click', '.nav-link', function (e) {
      e.preventDefault();
      
      $(this).closest('.dropdown').toggleClass('show');
      $(this).closest('.dropdown').find('.dropdown-menu').slideToggle();

      if ($(this).closest('.dropdown').hasClass('show')) {
          $(this).addClass('active');
      } else {
          $(this).removeClass('active');
      }
    });
  }

    $('.slider_img_with_text-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      autoplay: true,
      autoplaySpeed: 3000,
      asNavFor: '.slider_img_with_text-nav'
    });

    $('.slider_img_with_text-nav').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.slider_img_with_text-for',
      dots: true,
      focusOnSelect: true,
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            adaptiveHeight: true
          }
        }
      ]
    });

    $('.slider_image_with_text_for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.slider_image_with_text_nav',
      arrows: false,
      dots: false,
      fade: true,
      autoplay: false,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            adaptiveHeight: true
          }
        }
      ]
    });

    $('.slider_image_with_text_nav').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 3000,
      focusOnSelect: true,
      variableWidth: true,
      prevArrow: "<button class='slick-prev slick-arrow'><i class='fas fa-chevron-left'></i></button>", 
      nextArrow: "<button class='slick-next slick-arrow'><i class='fas fa-chevron-right'></i></button>",
      asNavFor: '.slider_image_with_text_for'
    });

    $('.quotes-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: "<button class='slick-prev slick-arrow'><i class='fas fa-chevron-left'></i></button>", 
      nextArrow: "<button class='slick-next slick-arrow'><i class='fas fa-chevron-right'></i></button>",
      responsive: [
        {
          breakpoint: 1199,
          settings: {
              dots: true,
              arrows: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        }
      ]
    });

    $('.highlights-banners').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            autoplay: true
          }
        }
      ]
    });

    $('.brands-homepage').slick({
      dots: false,
      arrows: true,
      infinite: false,
      adaptiveHeight: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: "<button class='slick-prev slick-arrow'><i class='fas fa-chevron-left'></i></button>", 
      nextArrow: "<button class='slick-next slick-arrow'><i class='fas fa-chevron-right'></i></button>",
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 992,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
              dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: true,
              arrows: false
          }
        },
        {
          breakpoint: 480,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
              arrows: false
          }
        }
      ]
    });

    // $('.content_faqs').slick({
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   asNavFor: '.FaqSummary',
    //   arrows: false,
    //   dots: false,
    //   fade: true,
    //   autoplay: false,
    //   autoplaySpeed: 3000,
    //   responsive: [
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         adaptiveHeight: true
    //       }
    //     }
    //   ]
    // });

    // $('.FaqSummary').slick({
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   arrows: true,
    //   autoplay: false,
    //   infinite: true,
    //   autoplaySpeed: 3000,
    //   focusOnSelect: true,
    //   variableWidth: true,
    //   prevArrow: "<button class='slick-prev slick-arrow'><i class='fas fa-chevron-left'></i></button>", 
    //   nextArrow: "<button class='slick-next slick-arrow'><i class='fas fa-chevron-right'></i></button>",
    //   asNavFor: '.content_faqs'
    // });

  var $animation_elements = $('.animation');
  var $window = $(window);

  function check_if_in_view() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);

    $.each($animation_elements, function() {
      var $element = $(this);
      var element_height = $element.outerHeight();
      var element_top_position = $element.offset().top;
      var element_bottom_position = (element_top_position + element_height);

      //check to see if this current container is within viewport
      if ((element_top_position <= window_bottom_position)) {
        $element.addClass('slideInUp');
      } 
      // else {
      //   $element.removeClass('slideInUp');
      // }
    });
  }

  $window.on('scroll resize', check_if_in_view);
  $window.trigger('scroll');
  
  (function ($) {
    $('.section--overflow').on('click', '.section-btn', function (e) {
        e.preventDefault();
        $(this).closest('.section--overflow').toggleClass('in');
        if ($(this).closest('.section--overflow').hasClass('in')) {
            $(this).html('<span>Read less</span>');
        } else {
            $(this).html('<span>Read more</span>');
        }
    });
  })(jQuery);

  if($('body').hasClass('template_page_our-app') == true){
    var plan_id = $('.template_page_our-app .section_select_plan .plan.selected').data('plan-id');
    var link_checkout = $('.template_page_our-app .section_select_plan .link_checkout').attr('href');
    if(link_checkout.indexOf("?")  > -1 ){
      $('.template_page_our-app .section_select_plan .link_checkout').attr('href', link_checkout + '&subscription=' + plan_id);
    } else{
      $('.template_page_our-app .section_select_plan .link_checkout').attr('href', link_checkout + '?subscription=' + plan_id);
    }
  }
  
  $('.section_select_plan').on('click', '.plan', function (e) {
    e.preventDefault();
    var plan_id = $(this).data('plan-id');
    var checkout = $('.section_select_plan .link_checkout');
    var link_checkout = checkout.attr('href');
    if ($(this).hasClass('selected') == false) {
      $('.section_select_plan .plans_options .plan').removeClass('selected');
      $(this).addClass('selected');
      if( link_checkout.indexOf("&subscription=") > -1 ) {
        var link_checkout = link_checkout.split("&subscription=")[0];
      } else if ( link_checkout.indexOf("?subscription=") ){
        var link_checkout = link_checkout.split("?subscription=")[0];
      }
      if(link_checkout.indexOf("?") > -1){
        checkout.attr('href', link_checkout + '&subscription=' + plan_id);
      } else{
        checkout.attr('href', link_checkout + '?subscription=' + plan_id);
      }
    }
  });
  
  $(".chargebee_actions input").on("keyup change", function(e) {
    var check_val = 0;
    $(".chargebee_actions .form_input").each(function( index ) {
      if (($(this).val() != null) && ($(this).val() != '')){
        check_val += 1;
      }
    });
    
    if (check_val == $(".chargebee_actions .form_input").length ){
      $(".chargebee_actions .checkout_btn").prop('disabled', false);
    }else {
      $(".chargebee_actions .checkout_btn").prop('disabled', true);
    }
  });
});